import BaseMap from 'components/BaseMap/BaseMap';
import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FaRegClock } from 'react-icons/fa6';
import '../../../../assets/dopplerRadar.css';
import DopplerMetaControls from '../DopplerMetaControls/DopplerMetaControls.jsx';
import DopplerPlaybackControls from '../DopplerPlaybackControls/DopplerPlaybackControls.jsx';

const DopplerMapControls = ({
  children,
  compact = false,
  mapProps,
  playbackProps,
  useSinglePanelCompactControls = false,
}) => {
  const [controlsExpanded, setControlsExpanded] = useState(true);
  const showMetaControls = !useSinglePanelCompactControls || !controlsExpanded;

  return (
    <BaseMap
      {...mapProps}
      mapViewAction={
        <Button
          type="button"
          size="sm"
          className={`doppler-map-view-action d-inline-flex align-items-center justify-content-center border-0 shadow-none rounded-3 px-2 ${
            controlsExpanded ? 'bg-primary text-white' : 'bg-white text-primary'
          }`}
          onClick={() => setControlsExpanded((isExpanded) => !isExpanded)}
          aria-expanded={controlsExpanded}
          aria-label={
            controlsExpanded ? 'Collapse animation controls' : 'Expand animation controls'
          }
        >
          <FaRegClock />
        </Button>
      }
      mapViewExpandedContent={
        controlsExpanded ? <DopplerPlaybackControls compact={compact} {...playbackProps} /> : null
      }
      mapViewHideLabelsToggle
    >
      {children}

      {showMetaControls && (
        <DopplerMetaControls
          compact={compact}
          frames={playbackProps.frames}
          displayedFrameIndex={playbackProps.displayedFrameIndex}
        />
      )}
    </BaseMap>
  );
};

export default DopplerMapControls;
